import * as React from 'react';
import { Container } from 'components/UI/Container/Container';
import { LrLogo } from 'components/Icons/LrLogo';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import { homepageLink } from '../../../helpers';
import { PrismicLink } from '../../PrismicLink';
import { SignupProps, UTMSourceMessage } from '.';

const SignupDefault = (props: SignupProps) => {
    const slice = props.slice.primary;
    const { iframeURL } = props;

    return (
        <Container className="Signup" size="md" data-testid="signupDefault">
            <Grid>
                <GridRow horizontalAlign={'h-center'} verticalAlign={'v-center'}>
                    <GridCol colSize={`5`} tabletColSize="8" mobileColSize="12">
                        <PrismicLink link={homepageLink(props.context.pageContext.lang)}>
                            <LrLogo />
                        </PrismicLink>
                        <PrismicHTMLParser>{slice.signup_title.html || ''}</PrismicHTMLParser>
                        <PrismicHTMLParser className="Signup-content">
                            {slice.signup_content.html || ''}
                        </PrismicHTMLParser>
                        {slice.signup_source_message && (
                            <UTMSourceMessage
                                params={props.params}
                                msg={slice.signup_source_message}
                            />
                        )}
                        {iframeURL && (
                            <iframe src={iframeURL} frameBorder="0" height="550px" width="100%" />
                        )}
                    </GridCol>
                </GridRow>
            </Grid>
        </Container>
    );
};

export { SignupDefault };
